import PropTypes from 'prop-types';
import get from 'lodash/get';
import classNames from 'clsx';
import { Link } from '../childPresentations/Link';
import PromptSelector from '../shared/PromptSelector';
import NowPlaying from '../../containerItems/childPresentations/NowPlaying';
import ContainerTitle from '../shared/ContainerTitle';
import EpisodeCard from '../../containerItems/childPresentations/EpisodeCard';
import ItemCard from '../../containerItems/childPresentations/ItemCard';
import AdCell from '../../containerItems/childPresentations/AdCell';

import containerItemsCss from '../container-items.module.scss';
import WebPrompt from './childPresentations/WebPrompt';
import PremiumTile from './childPresentations/PremiumTile';
import ScheduleTile from './childPresentations/ScheduleTile';
import Status from './childPresentations/Status';
import Default from './childPresentations/Default';

const presentationMap = {
  CompactStatus: Status,
  Link,
  EpisodeCard,
  ItemCard,
  ScheduleTile,
  Prompt: PromptSelector,
  WebPrompt,
  PremiumTile,
  NowPlaying,
  AdCell,
};

function getPresentation(presentation) {
  if (presentation) {
    return presentationMap[presentation.layout] || Default;
  }

  return Default;
}

const ListLayout = ({
  containerItem,
  selectedContentId,
  id,
  getStyles,
  matchUrl,
  breakpoint,
  isDarkMode,
  index,
  containerTitle,
  containerTitleClassName,
  maxChildren,
}) => {
  const children = maxChildren
    ? get(containerItem, 'children', []).slice(0, maxChildren)
    : get(containerItem, 'children');

  return (
    <div
      id={id}
      data-testid={id}
      data-testtype="listLayout"
      data-testcount={children ? children.length : 0}
    >
      <ContainerTitle
        containerItem={containerItem}
        getStyles={getStyles}
        className={classNames(
          containerItemsCss.contentSubHeader,
          containerTitleClassName,
        )}
        containerTitle={containerTitle}
      />
      <div data-testid="containerGuideItemsContainer">
        {children &&
          children.map((child, i) => {
            // some children won't have guideId's (e.g., AdCells), so this guarantees a unique
            // key for those children as well (e.g., `Ad-1`)
            const key = [child.type, child.guideId, i + 1]
              .filter(Boolean)
              .join('-');
            // temp fix for NP until platform figures out the issue with the response
            const ItemToUse =
              isDarkMode && index === 0 && i === 0
                ? NowPlaying
                : getPresentation(child.presentation);

            return (
              <ItemToUse
                key={key}
                guideItem={child}
                selectedContentId={selectedContentId}
                index={i}
                containerIndex={index}
                getStyles={getStyles}
                matchUrl={matchUrl}
                breakpoint={breakpoint}
              />
            );
          })}
      </div>
    </div>
  );
};

ListLayout.propTypes = {
  containerItem: PropTypes.object.isRequired,
  selectedContentId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  getStyles: PropTypes.func.isRequired,
  breakpoint: PropTypes.number.isRequired,
  matchUrl: PropTypes.string.isRequired,
  isDarkMode: PropTypes.bool,
  index: PropTypes.number,
  containerTitle: PropTypes.string,
  containerTitleClassName: PropTypes.string,
  maxChildren: PropTypes.number,
};

ListLayout.defaultProps = {
  getStyles: () => ({}),
};

export default ListLayout;
